import {cn} from '@sollapay/ui';

import {TimelineTable} from '@/components';

import {TRANSACTIONS_GRID_CLASS} from './BaseTransactionRow';
import {TransactionGroupHeader} from './TransactionGroupHeader';
import {TransactionRow} from './TransactionRow';

import type {TransactionGroupBy} from '@sollapay/enums';
import type {TrustAccountTransactionDTO, TrustAccountTransactionGroupDTO} from '@sollapay/types';
import type {ReactNode, FC} from 'react';

interface TransactionsTimelineTableProps {
  groups: TrustAccountTransactionGroupDTO[];
  groupBy: TransactionGroupBy;
  emptyState?: ReactNode;
}

export const TransactionsTimelineTable: FC<TransactionsTimelineTableProps> = ({
  groups,
  groupBy,
  emptyState
}) => {
  const timelineGroups = groups.map(group => ({
    id: group.groupKey,
    header: (
      <div className="col-span-full">
        <TransactionGroupHeader group={group} groupBy={groupBy} />
      </div>
    ),
    items: group.transactions
  }));

  return (
    <TimelineTable<TrustAccountTransactionDTO>
      groups={timelineGroups}
      renderItem={tx => <TransactionRow transaction={tx} />}
      getItemKey={tx => tx.id}
      emptyState={emptyState}
      className={cn(TRANSACTIONS_GRID_CLASS, 'gap-y-6')}
      groupClassName="col-span-full grid grid-cols-subgrid gap-y-4"
    />
  );
};
